export const SET_FILTER_ID = 'SET_FILTER_ID';
export const SetFilterId = (filteredId) => ({
    type: SET_FILTER_ID,
    payload: filteredId
});
